'use client';

import type { PropsWithChildren } from 'react';
import type { ApiError } from '@/app/hooks/useError';
import type { UserDataType } from '@/app/hooks/useUserData';
import { createContext, useContext } from 'react';
import { useUserData } from '@/app/hooks/useUserData';

const UserDataContext = createContext<ReturnType<typeof useUserData> | undefined>(undefined);

export const useUserDataContext = () => {
  const context = useContext(UserDataContext);
  if (context === undefined || context === null) {
    throw new Error(
      'useUserDataContext must be called within UserDataProvider',
    );
  }
  return context;
};

export function UserDataProvider({
  children,
  filter,
  data,
}: PropsWithChildren<{
  filter: Array<keyof UserDataType>;
  data: Promise<UserDataType & ApiError>;
}>) {
  const value = useUserData({ filter, data });

  return (
    <UserDataContext.Provider value={value}>
      {children}
    </UserDataContext.Provider>
  );
}
